import { MedtechRole } from '../types/medtechRole.types';
import { readOnly, normal, quality } from '../__stringConstants__/qualioConstants';

// Improvements Required: QUM-500, QUM-501
// NOTE: These now return translation keys - components should use t() to get the actual text
export const FeatureEnum: { [featureKey: string]: string } = {
  '1': 'features.qualityEvents.description',
  '2': 'features.migrations.description',

  // Quality Events permission Enums - now translation keys
  can_manage_quality_event_workflow: 'features.qualityEvents.permissions.manageWorkflow',
  can_manage_quality_event_attributes: 'features.qualityEvents.permissions.manageAttributes',
  can_work_on_issue: 'features.qualityEvents.permissions.workOnIssue',
  can_create_issue: 'features.qualityEvents.permissions.createIssue',

  // Migrations manager permission Enums - now translation keys
  can_create_migration: 'features.migrations.permissions.create',
  can_view_migration: 'features.migrations.permissions.view',
  can_prepare_migration: 'features.migrations.permissions.prepare',
  can_approve_migration: 'features.migrations.permissions.approve',
  can_upload_migration_files: 'features.migrations.permissions.uploadFiles',
};

export const FeatureToggleLabels: Record<string, string> = {
  1: 'features.qualityEvents.enable',
  2: 'features.migrations.enable',
} as const;

export const FeatureLabels: Record<string, string> = {
  1: 'features.qualityEvents.name',
  2: 'features.migrations.name',
} as const;

type AdminNavListItem = {
  href: string;
  title: string;
  component: string;
  id: string;
};

// NOTE: title fields now contain translation keys - components should use t() to get the actual text
export const NavList: {
  [k: string]: AdminNavListItem;
} = {
  USERS: {
    href: 'users',
    title: 'nav.users',
    component: 'users',
    id: 'users',
  },
  GROUPS: {
    href: 'groups',
    title: 'nav.groups',
    component: 'groups',
    id: 'groups',
  },
  DEV_API: {
    href: 'dev-api',
    title: 'nav.developerApiTokens',
    component: 'dev-api',
    id: 'dev-api',
  },
  PERMISSIONS: {
    href: 'permissions',
    title: 'nav.permissions',
    component: 'permissions',
    id: 'permissions',
  },
  BETAS: {
    href: 'betas',
    title: 'nav.betaFeatures',
    component: 'betaFeatures',
    id: 'betas',
  },
  SECURITY: {
    href: 'security',
    title: 'nav.security',
    component: 'security',
    id: 'security',
  },
};

export const UserGroupSortOrder = {
  [readOnly]: 1,
  [normal]: 2,
  [quality]: 3,
};

// NOTE: label fields now contain translation keys - components should use t() to get the actual text
export const UsergroupsList: { [role: string]: { value: MedtechRole; labelKey: string; sort: number } } = {
  QUALITY: {
    value: 'quality',
    labelKey: 'roles.quality', // Translation key
    sort: 3,
  },
  NORMAL: {
    value: 'normal',
    labelKey: 'roles.normal', // Translation key
    sort: 2,
  },
  BASIC: {
    value: 'read_only',
    labelKey: 'roles.basic', // Translation key
    sort: 1,
  },
};

export const UserActionItems = {
  EDIT_USER: {
    id: 'editUser',
    labelKey: 'users.editUser', // Translation key
  },
  CANCEL_INVITE: {
    id: 'cancelInvite',
    labelKey: 'users.cancelInvitation', // Translation key
  },
  REMOVE_USER: {
    id: 'removeUser',
    labelKey: 'users.removeUser', // Translation key
  },
  REMOVE_DECLINED_USER: {
    id: 'removeDeclinedUser',
    labelKey: 'users.cancelInvitation', // Translation key
  },
  RESEND_INVITE: {
    id: 'resendInvite',
    labelKey: 'users.resendInvitation', // Translation key
  },
};

export const NO_DATA_MSG = 'emptyStates.noData'; // Translation key

export const AssociationStatus = {
  FOR_REVIEW: {
    id: 'for_review',
    labelKey: 'status.forReview', // Translation key
  },
  EFFECTIVE: {
    id: 'effective',
    labelKey: 'status.effective', // Translation key
  },
  FOR_APPROVAL: {
    id: 'for_approval',
    labelKey: 'status.forApproval', // Translation key
  },
  DRAFT: {
    id: 'draft',
    labelKey: 'status.draft', // Translation key
  },
  APPROVAL_DECLINED: {
    id: 'approval_declined',
    labelKey: 'status.approvalDeclined', // Translation key
  },
  APPROVED: {
    id: 'approved',
    labelKey: 'status.approved', // Translation key
  },
};
